import { useSelector } from "react-redux";
import { selectCurrentOrgSetupItems } from "../../auth/state/selectors";

// Moved from _layouts/navigation/hooks - this is setup-checklist domain
// logic that was misplaced under the layout; SetupTracker (the sidenav
// widget) imports it from here now instead of a feature reaching backwards
// into a layout.
export const useSetupProgress = () => {
  const setupItems = useSelector(selectCurrentOrgSetupItems);

  const totalSetupItems = setupItems?.length || 0;

  const completedSetupItems =
    setupItems?.filter(
      (item) => item.tasks?.length > 0 && item.tasks.every((task) => task.completed)
    )?.length || 0;

  const isComplete = totalSetupItems > 0 && completedSetupItems === totalSetupItems;
  const percentage = totalSetupItems > 0 ? (completedSetupItems / totalSetupItems) * 100 : 0;

  return {
    completedSetupItems,
    totalSetupItems,
    percentage,
    isComplete,
  };
};
